import type { ReactNode } from 'react';

interface GoodsListSeoFooterSlotProps {
  children: ReactNode;
  isBot: boolean;
  isWeb: boolean;
  noMoreShow: boolean;
}

export default function GoodsListSeoFooterSlot({
  children,
  isBot,
  isWeb,
  noMoreShow,
}: GoodsListSeoFooterSlotProps) {
  const delayOnMobile = !isBot && !isWeb && !noMoreShow;

  return (
    <div data-goods-list-seo-footer-slot className={delayOnMobile ? 'hidden' : undefined}>
      {children}
    </div>
  );
}
